//http://72.61.174.79:5000

import axios from 'axios';

// const BASE_URL = process.env.REACT_APP_API_URL || 'https://api.insten.in/api';
const BASE_URL = 'https://api.insten.in/api';
// const BASE_URL ='http://localhost:5000/api';

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add Authorization token for each request
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // If it's a POST request with FormData (file upload), don't override the content type
    if (config.headers['Content-Type'] === 'application/json' && config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle 401/403 errors (e.g., token expired or unauthorized access)
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
